package com.fireavert.react.shared

// import react.dom.events.ChangeEvent // Not directly used with Autocomplete's new value
// import web.cssom.pct // Not used
import mui.material.Autocomplete
import mui.material.AutocompleteProps
import mui.material.FormControlVariant
import mui.material.TextField
import mui.system.sx
import react.*
import web.cssom.important
import web.cssom.px

// import web.html.HTMLInputElement // Not used

external interface SearchableDropDownListProps : Props {
    var labelText: String
    var optionMap: Map<String, Int?>
    var onChange: (Pair<Int?, String?>) -> Unit
    var mobileVersion: Boolean
    var disabled: Boolean
    var defaultValue: Int?
}

val SearchableDropDownList = FC<SearchableDropDownListProps> { props ->
    var internalStringValue by useState("")

    useEffect(props.defaultValue, props.optionMap) {
        val newStringValue = when {
            props.defaultValue == null -> props.optionMap.entries.firstOrNull { it.value == null }?.key ?: props.optionMap.keys.firstOrNull() ?: ""
            else -> props.optionMap.entries.firstOrNull { it.value == props.defaultValue }?.key ?: ""
        }
        if (newStringValue != internalStringValue) {
            internalStringValue = newStringValue
        }
    }

    val options = props.optionMap.keys.toTypedArray()

    Autocomplete<AutocompleteProps<String>> {
        this.options = options
        this.value = internalStringValue
        this.disabled = props.disabled

        onChange = { event, newSelectedString, reason, details ->
            // 1. Update local state immediately for responsiveness
            internalStringValue = (newSelectedString ?: "") as String
            // 2. Propagate the Int? value change to the parent
            val selectedIntValue = if (newSelectedString != null) {
                props.optionMap[newSelectedString]

            } else {
                // If user clears the selection (and it's clearable),
                // propagate the Int? value for the "null" option (e.g., "All")
                props.optionMap.entries.firstOrNull { it.value == null }?.value
            }
            props.onChange(Pair<Int?, String?>(selectedIntValue, newSelectedString as String?))
        }

        renderInput = { params ->
            TextField.create {
                variant = FormControlVariant.outlined
                label = ReactNode(props.labelText)
                fullWidth = true
                +params
            }
        }

        sx {
            "& .MuiAutocomplete-input" {
                minWidth = important(175.px)
            }
            if (!props.mobileVersion) {
                // Apply any non-mobile specific styling
            }
        }
    }
}